import React, { Component } from "react";
import style from "../../../assets/css/modules/shared/form/drop-down.css";
import InputTooltipIcon from "./InputTooltipIcon";

class DropDown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toolTipVisible: false
    };
  }

  render() {
    return (
      <React.Fragment>
        <label htmlFor={this.props.id} className={style.dropDownLabel}>
          {this.props.label}
        </label>

        <InputTooltipIcon tooltipContent={this.props.tooltipContent}>
          <select
            id={this.props.id}
            className={style.dropDown + " form-control custom-select"}
            onChange={event => this.props.onChange(event.target.value)}
          >
            {this.props.items.map((item, index) => (
              <option
                selected={item.DefaultSelected ? true : undefined}
                value={item.Value}
                key={index}
              >
                {item.Name}
              </option>
            ))}
          </select>
        </InputTooltipIcon>
      </React.Fragment>
    );
  }
}

export default DropDown;
